import React from "react";

export const ArrowUp = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
    <path d="M12 2L3.71 10.29a1 1 0 0 0 1.42 1.42L11 5.41V20a1 1 0 0 0 2 0V5.41l6.87 6.87a1 1 0 0 0 1.42-1.42L12 2z"/>
  </svg>
)